import { createSelector } from 'reselect';
import reportFiltersMap from './reportFiltersMap.js';
import { format } from 'date-fns';

const getLocationTimeZone = (locations, locationId) => {
  const location = (locations || []).find((n) => n.id === locationId) || locations[0];
  return (location || {}).timezone;
};

const formatDate = (dt, timeZone) => {
  let result;
  try {
    result = format(new Date(dt), 'yyyy-MM-dd', { timeZone });
  } catch (e) {
    return dt;
  }
  return result;
};

export const reportsFilterSelector = (filters, serviceProviderId, serviceProviderLocations, filteredLocationId) =>
  createSelector(filters, serviceProviderId, serviceProviderLocations, filteredLocationId, (filterSelector, serviceProviderId, locations, locationId) => {
    const filters = filterSelector;
    const filterSet = [
      'userId',
      'locationId',
      'servicePersonId',
      'reportsDateAggregate',
      'reportsPipelineLeadStatus',
      'reportsPipelineLeadSubStatus',
      'reportsReasonLost', //
      'serviceId',
      'serviceProviderId',
      'reportsGoodLeads',
      'reportsPipelineId',
      'reportsUtmSource',
      'reportsUtmMedium',
      'reportsUtmCampaign',
      'reportsEventType',
      'reportsPipelineStageId',
      'reportsMilestoneStageId',
      'reportsDateType',
      'form_type',
    ];

    const timezone = getLocationTimeZone(locations, locationId);
    const reportFilters = Object.entries(reportFiltersMap).map((n) => {
      return { key: n[0], value: n[1] };
    });

    const set = Object.entries(filters)
      .filter((n) => filterSet.includes(n[0]))
      .map((n) => {
        let newKey = (reportFilters.filter((o) => o.value === n[0]).pop() || {}).key;
        return [newKey, n[1]];
      })
      .concat([
        ['service_provider_id', serviceProviderId],
        ['start_date', formatDate((filters.datePicker || {}).startDate, timezone)],
        ['end_date', formatDate((filters.datePicker || {}).endDate, timezone)],
      ]);
    return Object.fromEntries(set);
  });
